import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Transport types
export type CarFuelOptions = "gasoline" | "diesel" | "hybrid" | "electric";
export type MotorcycleFuelOptions = "gasoline" | "electric";

export interface TransportState {
  carDistanceWeekly: number | null;
  carFuelType: CarFuelOptions | null;
  motorcycleDistanceWeekly: number | null;
  motorcycleFuelType: MotorcycleFuelOptions | null;
  busUseWeekly: number | null;
  subwayUseWeekly: number | null;
  railwayUseWeekly: number | null;
  nationalFlightsYearly: number | null;
  europeanFlightsYearly: number | null;
  internationalFlightsYearly: number | null;
}

const initialState: TransportState = {
  carDistanceWeekly: null,
  carFuelType: null,
  motorcycleDistanceWeekly: null,
  motorcycleFuelType: null,
  busUseWeekly: null,
  subwayUseWeekly: null,
  railwayUseWeekly: null,
  nationalFlightsYearly: null,
  europeanFlightsYearly: null,
  internationalFlightsYearly: null,
};

export const transportSlice = createSlice({
  name: "transport",
  initialState,
  reducers: {
    setCarFuelType(state, action: PayloadAction<CarFuelOptions | null>) {
      state.carFuelType = action.payload;
    },
    setCarDistanceWeekly(state, action: PayloadAction<number | null>) {
      state.carDistanceWeekly = action.payload;
    },
    setMotorcycleFuelType(
      state,
      action: PayloadAction<MotorcycleFuelOptions | null>
    ) {
      state.motorcycleFuelType = action.payload;
    },
    setMotorcycleDistanceWeekly(state, action: PayloadAction<number | null>) {
      state.motorcycleDistanceWeekly = action.payload;
    },
    setBusUseWeekly(state, action: PayloadAction<number | null>) {
      state.busUseWeekly = action.payload;
    },
    setSubwayUseWeekly(state, action: PayloadAction<number | null>) {
      state.subwayUseWeekly = action.payload;
    },
    setRailwayUseWeekly(state, action: PayloadAction<number | null>) {
      state.railwayUseWeekly = action.payload;
    },
    setNationalFlightsYearly(state, action: PayloadAction<number | null>) {
      state.nationalFlightsYearly = action.payload;
    },
    setEuropeanFlightsYearly(state, action: PayloadAction<number | null>) {
      state.europeanFlightsYearly = action.payload;
    },
    setInternationalFlightsYearly(state, action: PayloadAction<number | null>) {
      state.internationalFlightsYearly = action.payload;
    },
    setTransportState(state, action: PayloadAction<TransportState>) {
      state = action.payload;
    },
  },
});

export const {
  setCarFuelType,
  setCarDistanceWeekly,
  setMotorcycleFuelType,
  setMotorcycleDistanceWeekly,
  setBusUseWeekly,
  setSubwayUseWeekly,
  setRailwayUseWeekly,
  setNationalFlightsYearly,
  setEuropeanFlightsYearly,
  setInternationalFlightsYearly,
  setTransportState,
} = transportSlice.actions;

export default transportSlice.reducer;
